import {
  EnterpriseWorkspace,
  EnterpriseWorkspaceSettings,
} from "@app/common/workspaces/types";
import { sendEvent } from "@app/utils/tracking/Tracker";

export const changeWorkspaceSettings = sendEvent<
  Partial<EnterpriseWorkspaceSettings>
>("change_workspace_settings");

export const createWorkspace = sendEvent<{
  workspaceId: EnterpriseWorkspace["id"];
}>("create_workspace");

export const transferWorkspaceOwnership = sendEvent<{
  workspaceId: EnterpriseWorkspace["id"];
}>("transfer_workspace_ownership");

export const deleteWorkspace = sendEvent<{
  workspaceId: EnterpriseWorkspace["id"];
}>("delete_workspace");
